export default {"src":"/_next/static/media/JNPR.d5d2212c.svg","height":18,"width":18};